import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { BRAND } from "@/lib/brand";

export const GROUPS = { wine: "Wine", vintage: "Vintage", location: "Location", region: "Region", country: "Country", producer: "Producer", color: "Colour" };
export const eur = (n) => Number(n || 0).toLocaleString("pt-PT", { style: "currency", currency: "EUR" });

export const reportPdf = (rep, title, cave) => {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  doc.setFontSize(16);
  doc.text(title || "Cellar listing", 14, 16);
  doc.setFontSize(9);
  doc.setTextColor(110);
  doc.text(`${cave || ""} · ${new Date().toLocaleDateString("pt-PT")} · ${BRAND.domain}`, 14, 22);
  const head = [[...rep.group_by.map((g) => GROUPS[g]), "Wines", "Bottles", "Boxes", "Value"]];
  const body = rep.rows.map((r) => [...rep.group_by.map((g) => r[g]), r.wines, r.bottles, r.boxes, eur(r.value)]);
  const t = rep.totals;
  autoTable(doc, {
    startY: 27, head, body,
    foot: [["Total", ...Array(rep.group_by.length - 1).fill(""), t.wines, t.bottles, t.boxes, eur(t.value)]],
    styles: { fontSize: 8.5 }, headStyles: { fillColor: [23, 28, 26] }, footStyles: { fillColor: [245, 241, 232], textColor: 20 },
  });
  doc.save("grotalis-listing.pdf");
};
